document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector(".review-carousel__slider");
    const wrapper = slider.querySelector(".swiper-wrapper");
    const navPrev = document.querySelector(".review-carousel__nav--prev");
    const navNext = document.querySelector(".review-carousel__nav--next");
    const carouselSection = document.querySelector(".review-carousel");

    let swiperInstance = null;

    function getSlides() {
        return wrapper.querySelectorAll(".swiper-slide:not(.cloned-slide)");
    }

    function getClones() {
        return wrapper.querySelectorAll(".cloned-slide");
    }

    function isMobile() {
        return window.innerWidth < 768;
    }

    function duplicateSlidesIfNeeded() {
        const slides = getSlides();
        const cloneCount = getClones().length;

        if (isMobile() && slides.length <= 5 && cloneCount === 0) {
            slides.forEach(slide => {
                const clone = slide.cloneNode(true);
                clone.classList.add("cloned-slide");
                wrapper.appendChild(clone);
            });
        }

        if (!isMobile() && cloneCount > 0) {
            getClones().forEach(clone => clone.remove());
        }
    }

    function toggleNavigation(active) {
        if (navPrev) navPrev.classList.toggle("is-visible", active);
        if (navNext) navNext.classList.toggle("is-visible", active);
    }


    function initSwiper() {
        const slideCount = getSlides().length;

        if (slideCount <= 2) {
            destroySwiper();
            toggleNavigation(false);
            if (carouselSection) carouselSection.classList.add("is-static");
            return;
        }

        if (carouselSection) carouselSection.classList.remove("is-static");

        duplicateSlidesIfNeeded();

        if (swiperInstance) swiperInstance.destroy(true, true);

        swiperInstance = new Swiper(".review-carousel__slider", {
            slidesPerView: 1.284,
            spaceBetween: 15,
            centeredSlides: true,
            loop: true,
            navigation: {
                nextEl: ".review-carousel__nav--next",
                prevEl: ".review-carousel__nav--prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    centeredSlides: false,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    spaceBetween: 25,
                },
            }
        });

        const totalSlides = wrapper.querySelectorAll(".swiper-slide").length;
        const visibleSlides = window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1;
        const activateNav = totalSlides > visibleSlides;
        toggleNavigation(activateNav);
    }

    function destroySwiper() {
        if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    }

    function handleResize() {
        initSwiper();
    }

    // Init on load
    handleResize();

    // Re-check on resize
    window.addEventListener("resize", debounce(handleResize, 200));

    function debounce(func, delay) {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, delay);
        };
    }
});